import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import Badge from 'components/base/Badge';
import BasicLineChart from 'components/charts/e-charts/BasicLineChart';
import { getPastDates } from 'helpers/utils';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import type { RootState } from 'store';

const NewUsersAndLeads = () => {
  // Get dynamic data from Redux store
  const users = useSelector((state: RootState) => state.users.data);
  const assets = useSelector((state: RootState) => state.assets.data);

  // Calculate dynamic stats
  const totalUsers = users.length;
  const activeUsers = users.filter(user => user.is_active).length;

  // Calculate new users (users created in last 30 days)
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

  const newUsers = users.filter(user => {
    const userCreatedAt = new Date(user.created_at);
    return userCreatedAt > thirtyDaysAgo;
  }).length;

  // Calculate growth percentages (simplified - you can enhance this with real analytics)
  const newUsersGrowth = newUsers > 0 ? '+24.5%' : '+0%';
  const activeUsersGrowth = activeUsers > 0 ? '+30.5%' : '+0%';

  // Mock chart data - replace with real time-series data if available
  const newUsersChartData = [
    newUsers,
    newUsers,
    Math.round(newUsers * 0.8),
    Math.round(newUsers * 0.8),
    Math.round(newUsers * 0.8),
    Math.round(newUsers * 1.2),
    Math.round(newUsers * 1.2),
    Math.round(newUsers * 1.5),
    Math.round(newUsers * 1.5),
    Math.round(newUsers * 1.5),
    Math.round(newUsers * 1.3),
    Math.round(newUsers * 1.3)
  ];

  const activeUsersChartData = [
    Math.round(activeUsers * 0.3),
    Math.round(activeUsers * 0.3),
    Math.round(activeUsers * 0.6),
    Math.round(activeUsers * 0.5),
    Math.round(activeUsers * 0.7),
    Math.round(activeUsers * 0.4),
    Math.round(activeUsers * 0.5),
    Math.round(activeUsers * 0.5),
    Math.round(activeUsers * 0.6),
    Math.round(activeUsers * 0.5),
    Math.round(activeUsers * 0.6)
  ];

  return (
    <>
      <div className="mb-3">
        <h3>New Users </h3>
        {/* <p className="text-body-tertiary mb-0">
          Payment received across all channels
        </p> */}
      </div>
      <Row className="g-6">
        <Col md={6} className="mb-2 mb-sm-0">
          <div className="d-flex gap-2 align-items-center">
            <FeatherIcon icon="users" className="text-info" />{' '}
            <h4 className="text-body-tertiary mb-0">
              New Users : <span className="text-body-emphasis">{newUsers}</span>
            </h4>
            <Badge
              bg="success"
              variant="phoenix"
              iconPosition="end"
              className="fs-10"
            >
              {newUsersGrowth}
              <FontAwesomeIcon
                icon={faCaretUp}
                className="d-inline-block lh-1 ms-1"
                transform="down-2"
              />
            </Badge>
          </div>
          <div className="pb-0 pt-4">
            <BasicLineChart
              data={newUsersChartData}
              dates={getPastDates(12)}
              style={{ height: 110, width: '100%' }}
            />
          </div>
        </Col>
        <Col md={6}>
          <div className="d-flex gap-2 align-items-center">
            <FeatherIcon icon="zap" className="text-primary" />{' '}
            <h4 className="text-body-tertiary mb-0">
              Current Users :{' '}
              <span className="text-body-emphasis">{activeUsers}</span>
            </h4>
            <Badge
              bg="success"
              variant="phoenix"
              iconPosition="end"
              className="fs-10"
            >
              {activeUsersGrowth}
              <FontAwesomeIcon
                icon={faCaretUp}
                className="d-inline-block lh-1 ms-1"
                transform="down-2"
              />
            </Badge>
          </div>
          <div className="pb-0 pt-4">
            <BasicLineChart
              data={activeUsersChartData}
              dates={getPastDates(11)}
              style={{ height: 110, width: '100%' }}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default NewUsersAndLeads;
